import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const castle = defineConnector({
  identifier: "castle",
  name: "Castle.io",
  tagLine: "Fraud and abuse prevention",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api.castle.io/.*",
  auth: (app) =>
    basicAuth({
      username: "",
      password: app.secret.accessToken,
    }),
  steps: [
    {
      title: "Create a token in Castle.io",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.castle.io/docs/integration-guide](https://docs.castle.io/docs/integration-guide) to create a token for the Castle.io API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.castle.io/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.castle.io/")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
